export const getCSRF = state => state.csrf.csrf;
export const getTheme = state => state.general.theme;
export const getConfig = state => state.general.config;
